import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import PropTypes from "prop-types";
import React, { useState } from "react";
import BuyOnStoreButton from "web/react/components/buy-on-store-button/buy-on-store-button";
import classnames from "classnames";
import ColorPicker from "web/react/components/color-picker/color-picker";
import HintBubble from "web/react/components/hint-bubble/hint-bubble";
import { languageIsEnglish } from "web/script/modules/language";
import PriceInfo from "web/react/components/price-info/price-info";
import ProductDescriptionDetails from "web/react/components/product-description/product-description-details/product-description-details";
import ProductDescriptionExpressCheckout from "web/react/components/product-description/product-description-express-checkout/product-description-express-checkout";
import ProductDescriptionHeader from "web/react/components/product-description/product-description-header/product-description-header";
import ProductDescriptionPriceHistoryBullet from "web/react/components/product-description/product-description-price-history-bullet/product-description-price-history-bullet";
import ProductDescriptionShipping from "web/react/components/product-description/product-description-shipping/product-description-shipping";
import ProductDescriptionComparePrice from "web/react/components/product-description/product-description-compare-prices/product-description-compare-prices";
import SaveForLaterButton from "web/react/components/save-for-later-button/save-for-later-button";
import SizePicker from "web/react/components/size-picker/size-picker";
import { gettext } from "web/script/modules/django-i18n";
import userProfiler from "web/script/modules/userprofiler";
import { BuyOptionPropType } from "web/types/buy-option";
import { DesignerPropType } from "web/types/designer";
import { ProductPropType } from "web/types/product";
import SendToAppModal from "web/react/components/send-to-app-modal/send-to-app-modal";
import { RawBranchLink, FinancialIncentivesCampaignRawBranchLink } from "web/script/utils/branch-io";
import browser from "web/script/utils/browser";
import environment from "web/script/modules/environment";
import history from "web/script/utils/history";
import analytics from "web/script/analytics/analytics";
import { useOverlayWatcher } from "web/react/hooks/use-overlay-watcher/use-overlay-watcher";
import Promos from "./product-area-promos/product-area-promos";
import styles from "./product-area.css";
var DEFAULT_BLOCK = "soft_block";
var NO_BLOCK = "no_block";
var APP_MODAL_NAME = "send-to-app-on-is-product-shop-now-modal";
export var ProductAreaPropType = PropTypes.shape({
  all_sizes_sorted: PropTypes.array,
  buy_options: PropTypes.objectOf(BuyOptionPropType).isRequired,
  should_display_sizes: PropTypes.bool,
  products: PropTypes.objectOf(ProductPropType).isRequired,
  designer: DesignerPropType.isRequired,
  absolute_url: PropTypes.string.isRequired,
  is_product_area_accordions_enabled: PropTypes.bool,
  sorted_buy_options: PropTypes.arrayOf(PropTypes.string).isRequired,
  sorted_variants: PropTypes.arrayOf(PropTypes.string).isRequired,
  available_sizes: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  lead_label: PropTypes.string.isRequired,
  terms_url: PropTypes.string.isRequired,
  show_express_checkout: PropTypes.bool.isRequired,
  size_guide_link: PropTypes.string,
  express_sizes: PropTypes.arrayOf(PropTypes.shape({
    option_value: PropTypes.shape({
      link_id: PropTypes.string,
      raw_size: PropTypes.string,
      icon: PropTypes.bool
    }),
    human_size: PropTypes.string,
    raw_size: PropTypes.string,
    min_price: PropTypes.string
  })),
  price_history_bullet: PropTypes.string,
  is_express_checkout_size_test: PropTypes.bool,
  express_checkout_disclaimer: PropTypes.bool,
  bing_traffic: PropTypes.bool
});

function ProductArea(_ref) {
  var _classnames;

  var _ref$productArea = _ref.productArea,
      allSizesSorted = _ref$productArea.all_sizes_sorted,
      buyOptions = _ref$productArea.buy_options,
      shouldDisplaySizes = _ref$productArea.should_display_sizes,
      products = _ref$productArea.products,
      designer = _ref$productArea.designer,
      isProductAreaAccordionsEnabled = _ref$productArea.is_product_area_accordions_enabled,
      allSortedBuyOptions = _ref$productArea.sorted_buy_options,
      sortedVariants = _ref$productArea.sorted_variants,
      leadLabel = _ref$productArea.lead_label,
      termsUrl = _ref$productArea.terms_url,
      showExpressCheckout = _ref$productArea.show_express_checkout,
      sizeGuideLink = _ref$productArea.size_guide_link,
      expressSizes = _ref$productArea.express_sizes,
      priceHistoryBullet = _ref$productArea.price_history_bullet,
      bingTraffic = _ref$productArea.bing_traffic,
      handleProductChange = _ref.handleProductChange,
      selectedVariant = _ref.selectedVariant;

  if (!selectedVariant) {
    // If we're rendered by the old PDP code, we won't get this prop and need to improvise
    selectedVariant = sortedVariants[0];
  }

  var product = products[selectedVariant];
  var sortedBuyOptions = allSortedBuyOptions.filter(function (linkId) {
    return product.link_ids.includes(linkId);
  });
  var buyOption = buyOptions[sortedBuyOptions[0]];
  var size = buyOption.sizes[buyOption.default_size];
  var isLoggedIn = React.useMemo(function () {
    return userProfiler.isLoggedIn();
  }, []);
  var currentPriceHtml = size.formatted_sale_price;
  var priceWithCurrencySymbol = size.formatted_price;
  var selectedShipping;
  var freeShipping;
  var expressShipping;
  var freeReturn = false;

  if (size.returns) {
    freeReturn = size.returns.is_free;
  }

  if (size.shipping_info) {
    var _size$shipping_info = size.shipping_info,
        cheapest = _size$shipping_info.cheapest,
        guaranteed = _size$shipping_info.cheapest_guaranteed,
        fastest = _size$shipping_info.fastest;

    if (cheapest && cheapest.is_free) {
      freeShipping = cheapest;
    }

    if (guaranteed) {
      selectedShipping = guaranteed;
    } else {
      selectedShipping = cheapest;
    }

    expressShipping = fastest;
  }

  var shouldRenderShipping = freeShipping || expressShipping || freeReturn;
  var promotion;

  if (size.promotion) {
    var promo = size.promotion;
    var retailerTerms = promo.terms_url;

    if (!retailerTerms) {
      retailerTerms = size.lead_url;
    }

    promotion = {
      tcs: [{
        // "Lyst promotion terms apply"
        message: gettext("in_stock_product.lyst_promotion_terms_link"),
        url: termsUrl
      }, {
        // "{retailer_name} promotion terms apply"
        message: gettext("in_stock_product.retailer_promotion_terms_link", {
          retailer_name: buyOption.retailer_name
        }),
        url: retailerTerms
      }],
      message: promo.html_message,
      url: promo.url
    };
  } // TODO: Move this to product-description-price when we kill the old serializer
  // "Price last checked {interval}"


  var humanLastChecked = gettext("in_stock_product.last_checked_at", {
    interval: buyOption.date_updated_human
  });
  var isIos = browser.ios;
  var blockVariant = NO_BLOCK; // Always get to the best price faster in the app

  var sendToAppTitle = gettext("is_product.shop_now.app_overlay_block.title_1");
  var sendToAppBranchLink = RawBranchLink.InStockShopNow;
  var sendToAppFinancialIncentiveWebviewToken;
  var downloadAppCTA;

  if (isIos && promotion == null && languageIsEnglish()) {
    blockVariant = DEFAULT_BLOCK;

    if (environment.getFeature("mg_block_affiliate_shop_now_fi")) {
      // Get {reward_value} back as a reward if you buy through the Lyst App
      sendToAppTitle = gettext("financial_incentive.app_download_overlay.title", {
        reward_value: "10%"
      });
      sendToAppBranchLink = FinancialIncentivesCampaignRawBranchLink.InStockModal;
      sendToAppFinancialIncentiveWebviewToken = environment.getFeature("mg_block_affiliate_shop_now_fi"); // Get {reward_value} back on this item

      downloadAppCTA = gettext("financial_incentive.is_shop_now_app_download_overlay.cta", {
        reward_value: "10%"
      });
    }
  } // PMT-212 - Show shipping info in accordian instead of overlay for EC products


  var expressShippingLinkId = null;

  if (showExpressCheckout) {
    isProductAreaAccordionsEnabled = true;
    expressShippingLinkId = sortedBuyOptions[0];
  } // MG-194 - Add Hard/Soft block to Download App on Shop Now button


  var retailAreaText;

  if (blockVariant !== NO_BLOCK && !showExpressCheckout) {
    // Best price from over 450 stores
    retailAreaText = gettext("in_stock_product.from_450_stores.label");
  }

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      blocked = _useState2[0],
      setBlocked = _useState2[1];

  var blockModalIsOpen = !!useOverlayWatcher(APP_MODAL_NAME);

  function onBlockModalOpen() {
    if (history.getCurrentState().overlay !== APP_MODAL_NAME) {
      history.pushOverlay(APP_MODAL_NAME);
    }
  }

  function onButtonClick(callbackFunction, event) {
    analytics.event("buy_area", "clicked", "buy-on-store-button");
    event.preventDefault();

    if (isIos && !userProfiler.isLoggedIn()) {
      if (blockVariant === DEFAULT_BLOCK && blocked) {
        setBlocked(false);
        onBlockModalOpen();
        return;
      }
    } // If we don't meet the requirements to open the modal, we immediately invoke the callback


    callbackFunction(event);
  }

  function onBlockModalClose() {
    history.popOverlay(APP_MODAL_NAME);
  }

  var saveForLaterButton = React.createElement(SaveForLaterButton, {
    isLoggedIn: isLoggedIn,
    type: "normal",
    fullWidth: false,
    productId: product.product_id,
    pageSource: "pdp" // "Track deals"
    ,
    cta: showExpressCheckout ? gettext("designer_updates.track_deals_btn_text") : undefined,
    showExpressCheckout: showExpressCheckout,
    bingTraffic: bingTraffic
  });
  var expressCheckoutBuyOnStoreButton = React.createElement(BuyOnStoreButton, {
    productId: product.product_id,
    leadUrl: size.lead_url,
    leadLabel: leadLabel,
    bingTraffic: bingTraffic
  });
  var productDescriptionExpressCheckoutClassname = styles.expressBuySection;
  var productDescriptionExpressCheckout = React.createElement(ProductDescriptionExpressCheckout, {
    className: productDescriptionExpressCheckoutClassname,
    sizeGuideLink: sizeGuideLink,
    sizes: expressSizes,
    leadUrl: size.lead_url,
    leadLabel: buyOption.retailer_name,
    productId: product.product_id,
    bingTraffic: bingTraffic,
    storeLeadUrl: size.lead_url
  });
  return React.createElement("div", null, React.createElement(ProductDescriptionHeader, {
    className: styles.headerSection,
    designerName: designer.name,
    designerUrl: designer.url,
    isDesignerActive: designer.active,
    shortDescription: product.short_description
  }), React.createElement("div", {
    className: styles.section
  }, React.createElement("div", {
    className: styles.price
  }, React.createElement(PriceInfo, {
    isOnSale: size.is_on_sale,
    retailerName: buyOption.retailer_name,
    leadUrl: size.lead_url,
    formattedPrice: priceWithCurrencySymbol,
    selectedShipping: selectedShipping,
    currentPriceHtml: currentPriceHtml,
    retailAreaText: retailAreaText
  }), sortedBuyOptions.length > 1 && blockVariant === NO_BLOCK && React.createElement(ProductDescriptionComparePrice, {
    allSizesSorted: allSizesSorted,
    buyOptions: buyOptions,
    shouldDisplaySizes: shouldDisplaySizes,
    sortedBuyOptions: sortedBuyOptions,
    inlineVariant: true
  })), React.createElement(Promos, {
    promotion: promotion
  }), !showExpressCheckout && React.createElement("div", {
    className: classnames(styles.leadButtons, styles.buttonsInRow)
  }, React.createElement(BuyOnStoreButton, {
    productId: product.product_id,
    leadUrl: size.lead_url,
    leadLabel: leadLabel,
    beforeOnClick: onButtonClick
  }), languageIsEnglish() && React.createElement(SaveForLaterButton, {
    isLoggedIn: isLoggedIn,
    type: "normal",
    fullWidth: false,
    productId: product.product_id,
    pageSource: "pdp" // "Track deals"
    ,
    cta: gettext("designer_updates.track_deals_btn_text")
  })), React.createElement("div", {
    className: classnames(styles.leadButtons, (_classnames = {}, _defineProperty(_classnames, styles.buttonsInColumn, !showExpressCheckout), _defineProperty(_classnames, styles.expressCheckoutButtonsInRow, showExpressCheckout), _classnames))
  }, !showExpressCheckout && React.createElement(BuyOnStoreButton, {
    productId: product.product_id,
    leadUrl: size.lead_url,
    leadLabel: leadLabel
  }), languageIsEnglish() && saveForLaterButton, showExpressCheckout && expressCheckoutBuyOnStoreButton), humanLastChecked && buyOption.is_amazon && React.createElement("div", {
    className: styles.lastCheckedWrapper
  }, React.createElement(HintBubble, {
    tooltipText: gettext("in_stock_product.last_checked_at_tooltip") // "Product prices and availability are accurate as of the date/time indicated and are subject to change. Any price and availability information displayed on partners' sites at the time of purchase will apply to the purchase of this product."

  }), React.createElement("span", {
    title: buyOption.date_updated
  }, humanLastChecked)), React.createElement(SendToAppModal, {
    title: sendToAppTitle,
    url: sendToAppBranchLink,
    isOpen: blockModalIsOpen,
    onClose: onBlockModalClose,
    analyticsEventLabel: "is-product-shop-now",
    productImageURL: product.images[0].full_size_url,
    trackedLink: {
      leadUrl: size.lead_url,
      productId: product.product_id,
      reason: "continue-to-retailer"
    },
    financialIncentiveWebviewToken: sendToAppFinancialIncentiveWebviewToken,
    downloadCTA: downloadAppCTA
  })), shouldDisplaySizes && allSizesSorted && React.createElement("div", {
    className: styles.section
  }, React.createElement("div", {
    className: styles.inlineSubHeader
  }, React.createElement("h3", {
    className: styles.title
  }, gettext("in_stock_product.sizes.title") // Sizes
  , ":"), sortedBuyOptions.length > 1 && blockVariant === NO_BLOCK && React.createElement(ProductDescriptionComparePrice, {
    allSizesSorted: allSizesSorted,
    shouldDisplaySizes: shouldDisplaySizes,
    inlineVariant: true,
    buyOptions: buyOptions,
    sortedBuyOptions: sortedBuyOptions,
    title: gettext("in_stock_product.shop_all_sizes.link") // Shop All Sizes
    ,
    analyticsTitle: "shop_all_sizes"
  })), React.createElement(SizePicker, {
    allSizesSorted: allSizesSorted,
    buyOptionSizes: buyOption.sizes
  })), sortedVariants.length > 1 && React.createElement("div", {
    className: styles.section
  }, React.createElement("h3", {
    className: styles.title
  }, gettext("in_stock_product.colors.title") // Colors
  , ":"), React.createElement(ColorPicker, {
    allSortedBuyOptions: allSortedBuyOptions,
    buyOptions: buyOptions,
    current: selectedVariant,
    onClick: handleProductChange,
    variants: sortedVariants,
    products: products
  })), showExpressCheckout && productDescriptionExpressCheckout, (shouldRenderShipping || showExpressCheckout) && React.createElement(ProductDescriptionShipping, {
    productAreaAccordions: isProductAreaAccordionsEnabled,
    leadUrl: size.lead_url,
    retailerName: buyOption.retailer_name,
    freeShipping: freeShipping,
    freeReturn: freeReturn,
    expressShipping: expressShipping,
    className: styles.section,
    linkId: expressShippingLinkId
  }), priceHistoryBullet && React.createElement(ProductDescriptionPriceHistoryBullet, {
    productAreaAccordions: isProductAreaAccordionsEnabled,
    className: styles.section,
    priceHistoryBullet: priceHistoryBullet
  }), React.createElement(ProductDescriptionDetails, {
    className: classnames(styles.section, _defineProperty({}, styles.detailsSectionAccordion, isProductAreaAccordionsEnabled)),
    product: product,
    productAreaAccordions: isProductAreaAccordionsEnabled
  }));
}

ProductArea.propTypes = {
  productArea: ProductAreaPropType.isRequired,
  handleProductChange: PropTypes.func,
  selectedVariant: PropTypes.string
};
export default ProductArea;